<template>
  <div class="navigation">
    <nav class="navbar--dark">
      <div class="navbar--brand" v-if="isHome">
        <div class="navbar-item none" v-scroll-to="'#klinische-diagnostik'">
          Klinische Diagnostik
        </div>
        <div class="navbar-item none" v-scroll-to="'#behandlung-und-beratung'">
          Behandlung & Beratung
        </div>
        <div class="navbar-item none" v-scroll-to="'#befunde-und-gutachten'">
          Befunde & Gutachten
        </div>
        <div class="navbar-item none" v-scroll-to="'#sportpsychologie'">
          Sportpsychologie
        </div>
        <div class="navbar-item none" v-scroll-to="'#notfallpsychologie'">
          Notfallpsychologie
        </div>
        <div class="navbar-item none" v-scroll-to="'#supervision'">
          Supervision
        </div>
        <div class="navbar-item none" v-scroll-to="'#kontakt-und-termin'">
          Kontakt & Termin
        </div>
      </div>
      <div class="navbar--brand" v-else>
        <router-link class="navbar-item none" title="PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer" :to="{ name: 'Home'}">
          <span>Home</span>
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'app-navigation',
  props: {
    isHome: true,
    mobileClass: true,
    mobileHidden: false
  }
}
</script>

<style lang="scss">
@import "../assets/scss/variables";

.navigation {
  .navbar {
    &--dark {
      background-color: $dark;
      padding: 1rem;

      .navbar {
        &--brand {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .navbar-item {
            padding: 0.5rem;
            display: inline-block;
            color: white;
            text-decoration: none;
            border-bottom: 1px solid;
            box-sizing: border-box;
            border-color: transparent;
            box-shadow: none;

            &:hover,
            &:focus {
              border-color: white;
              cursor: pointer;
              transition: border 500ms ease;
            }
          }
        }
      }

      @media screen and (max-width: $break-md) {
        .navbar {
          &--brand {
            display: block;
            text-align: center;

            .navbar-item {
              margin-top: 0.5rem;
              margin-bottom: 0.5rem;
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue